export abstract class ObjectUtil {

    public static cloneAttributs(objectToClone: any): any {
        let cloneObj: any;
        if (typeof objectToClone !== 'object') {
            cloneObj = objectToClone;
        } else {
            cloneObj = [];
            for (let attribut in objectToClone) {
                if (typeof objectToClone[attribut] === 'object') {
                    cloneObj[attribut] = ObjectUtil.cloneAttributs(objectToClone[attribut]);
                } else {
                    cloneObj[attribut] = objectToClone[attribut];
                }
            }
        }
        return cloneObj;
    }
}





// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/util/objectUtil.ts